<template>
  <main id="output">
      <Menu />
      <transition name="fade">
        <RemoteCodeForm v-if="remoteForm" @connectWS="connectWS" />
      </transition>
      <PickedNames v-if="showPickedNames" />
      <Wheel v-if="activeNamePicker === 'wheel'" ref="namepicker" :roster="roster" />
      <Namestack v-if="activeNamePicker === 'namestack'" ref="namepicker"  :roster="roster" />
      <Slotmachine v-if="activeNamePicker === 'slotmachine'" ref="namepicker"  :roster="roster" />
      <footer>
        <button class="btn solid" @click.prevent="restart" v-if="!roster.length">Restart</button>
        <button class="btn solid" @click.prevent="trigger" v-if="roster.length">Pick me a namn</button>
      </footer>
  </main>
</template>

<script>
import Menu from '@/components/Menu';
import Wheel from '@/components/namepickers/Wheel';
import Namestack from '@/components/namepickers/Namestack';
import Slotmachine from '@/components/namepickers/Slotmachine';
import PickedNames from '@/components/PickedNames';
import RemoteCodeForm from '@/components/RemoteCodeForm';
import { io } from 'socket.io-client';

export default {
    name: 'Output',
    components: {
      Menu,
      RemoteCodeForm,
      Wheel,
      Namestack,
      Slotmachine,
      PickedNames
    },
    methods: {
      trigger(){
        this.$refs.namepicker.trigger();
      },
      restart(){
        this.$store.dispatch('submit', true);
      },
      connectWS(code){
        const socket = io({path: '/selfie/socket.io'}); //io("http://localhost:3000");
        socket.emit('joinRoom', { code: code });

        socket.on('connect', () => {
          console.log('I am connected');
          this.$store.state.UIstate.remoteActive = true;
        });

        socket.on('disconnect', () => {
          this.$store.state.UIstate.remoteActive = false;
        })

        socket.on('trigger', () => {
          this.trigger();
        });

      }
    },
    computed: {
      roster(){
        return this.$store.state.shuffledNames;
      },
      activeNamePicker(){
        return this.$route.params.namepicker;
      },
      showPickedNames(){
        return this.$store.state.settings.showPickedNames;
      },
      remoteForm(){
        return this.$store.state.UIstate.remoteForm;
      }
    },
    beforeMount(){
      this.$store.commit('configMenuUI', { 
        close: false, 
        back: true,
        navicon: false,
        remote: true
      })
    }
}
</script>

<style lang="scss">
@import './../scss/variables';

#output {
  background: $selfieGradient;
  @include center;
  flex-direction: column;
  height: 100vh;

  > footer {
    position: fixed;
    bottom: 2rem;
    z-index: 999;
  }
}
</style>